import React, { Component, Fragment } from 'react';

import Speaker from '../../components/Speaker';
import AppActions from '../../lib/flux/AppActions'
import AppActionTypes from '../../lib/flux/AppActionTypes'
import AppStore from '../../lib/flux/AppStore';

import { TweenLite } from 'gsap';

import { speakers } from '../../lib/data'

import './Lineup.scss';

const indexes = speakers.list.length - 1;
const useScroll = false;

class Gallery extends Component {
    constructor(props) {
        super(props);
        this.state = {
            ...AppStore.getSpeaker()
        }
    }

    componentDidMount = () => {
        AppStore.on(AppActionTypes.SPEAKER, this._handleStoreSpeakerChange);
        // window.addEventListener('scroll', this.handleScroll);
        window.addEventListener('keydown', this.handleKeyDown);
        this.updateDimensions();
        window.addEventListener("resize", this.updateDimensions);
        this.in();
    }

    componentWillUnmount = () => {
        AppStore.removeListener(AppActionTypes.SPEAKER, this._handleStoreSpeakerChange);
        // window.removeEventListener('scroll', this.handleScroll);
        window.removeEventListener('keydown', this.handleKeyDown);
        window.removeEventListener("resize", this.updateDimensions);
    }

    updateDimensions = () => {

        const w = window.innerWidth;
        let pos = AppStore.getSpeaker().position * w
        // console.log(pos)

        if (!useScroll) {
            TweenLite.set(this.refs.speakers, { marginLeft: -pos })
        }
    }


    _handleStoreSpeakerChange = ({ speaker, move, position }) => {
        // console.log('Lineup.js _handleStoreSpeakerChange()', { speaker, move, position }, this.state);
        if (move) {
            move >= 1 ? this.onNext(this.open) : this.onPrevious(this.open);
            // don't setState here because this will fire again once the movement finishes
        } else {
            this.setState(AppStore.getSpeaker())
        }
    }

    in = () => {
        TweenLite.set(this.refs.speakers, { opacity: 0 });
        TweenLite.to(this.refs.speakers, 1, { opacity: 1, ease: 'easeInOutExpo' });
    }

    // handleScroll = () => {
    // 
    // }

    handleKeyDown = (e) => {
        e = e || window.event;
        //e.preventDefault();
        switch (e.keyCode) {
            case 37:
                // left    
                if (!AppStore.getSpeaker().speaker) {
                    this.onPrevious();
                }
                break;
            // case 38:
            //     // up    
            //     this.open();
            //     break;
            case 39:
                // right
                if (!AppStore.getSpeaker().speaker) {
                    this.onNext()
                }
                break;
            // case 40:
            //     // down
            //     // close is handled in the Header.js file
            //     break;
            default:
                break;
        }
    }

    open = () => {
        const s = AppStore.getSpeaker();
        // console.log('open()', s)
        if (!s.speaker) {
            this.onBioClick({ id: speakers.list[s.position], index: s.position })
        }
    }

    seekToPosition = ({ index, callback }) => {
        if (!callback) {
            callback = () => { }
        }
        // console.log('seekToPosition()', { index });
        const w = window.innerWidth;
        let pos = index ? index * w : 0 * w
        // console.log(pos)

        if (useScroll) {
            TweenLite.to(this.refs.speakers, .75, {
                scrollLeft: pos, ease: 'easeInOutExpo', onComplete: () => {
                    AppActions.speaker({ position: index }, callback);
                }
            })
        } else {
            TweenLite.to(this.refs.speakers, .75, {
                marginLeft: -pos, ease: 'easeInOutExpo', onComplete: () => {
                    AppActions.speaker({ position: index }, callback);
                }
            })
        }



    }

    onPrevious = (callback) => {
        // console.log('onPrevious()');
        setTimeout(() => {
            AppActions.speaker({ move: null }, () => {
                this.seekToPosition({ index: this.getPrevious(), callback });
            })
        }, 25)
    }

    onNext = (callback) => {
        // console.log('onNext()');
        setTimeout(() => {
            AppActions.speaker({ move: null }, () => {
                this.seekToPosition({ index: this.getSecondary(), callback });
            })
        }, 25);
    }

    getPrevious = () => {
        // console.log('getPrevious()');
        const position = AppStore.getSpeaker().position;
        return position === 0 ? indexes : position - 1;
    }

    getSecondary = () => {
        // console.log('getSecondary()');
        const position = AppStore.getSpeaker().position;
        return position === indexes ? 0 : position + 1;
    }

    onBioClick = ({ id, index }) => {
        // console.log('onBioClick()', id)
        AppActions.speaker({ speaker: id, move: null, position: index }, () => {
            setTimeout(() => {
                AppActions.header({ speaker: true, hidden: false });
            }, AppStore.getHeader().speaker ? 1000 : 0)
        })
    }

    buildSpeakers = () => {

        return speakers.list.map((key, index) => {

            let speaker = speakers.dictionary[key];

            return (
                <div className={`speakers`} key={`${key}-f`}>
                    <Speaker
                        src={speaker.image}
                        mobile={speaker.mobileimage}
                        id={key}
                        index={index}
                        key={`${key}-s`}
                        name={speaker.name}
                        title={speaker.title}
                        bio={speaker.bio}
                        offsets={speaker.offsets}
                        linkcolor={speaker.linkcolor}
                        forcelinkcolor={speaker.forcelinkcolor}
                        onClick={() => { this.onBioClick({ id: key, index }) }}
                    />
                </div>
            )
        })

    }

    render() {
        return (
            <div className="Lineup">
                <div className={`lineup-mask` + (useScroll === true ? ` scrollable` : ``)} id="speakers-scroll" ref="speakers" >
                    <div className="lineup-container">
                        {this.buildSpeakers()}
                    </div>
                </div>
                {!this.state.speaker && (
                    <div className={`arrows`} ref={'arrows'}>
                        <div className="arrow-l" onClick={this.onPrevious}></div>
                        <div className="arrow-r" onClick={this.onNext}></div>
                    </div>
                )}
            </div>
        );
    }
}

export default Gallery;